/* unplugin-vue-components disabled */import { render } from "./pwa-modal.vue?vue&type=template&id=6e67f97a&scoped=true"
import script from "./pwa-modal.vue?vue&type=script&lang=js"
export * from "./pwa-modal.vue?vue&type=script&lang=js"

import "./pwa-modal.vue?vue&type=style&index=0&id=6e67f97a&lang=stylus"
import "./pwa-modal.vue?vue&type=style&index=1&id=6e67f97a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e67f97a"],['__file',"src/components/pwa-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e67f97a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e67f97a', __exports__)) {
    api.reload('6e67f97a', __exports__)
  }
  
  module.hot.accept("./pwa-modal.vue?vue&type=template&id=6e67f97a&scoped=true", () => {
    api.rerender('6e67f97a', render)
  })

}


export default __exports__